module.exports = __webpack_public_path__ + "static/media/plus-icon.31c28029.svg";